import React from 'react'
import { Provider } from 'react-redux'
import configureStore from './app/store'

import App from './app'

const Bootstrap = ({ children }) => {
  const store = configureStore(window.initialData)
  const head = document.getElementsByTagName('head')[0]
  head.insertAdjacentHTML('beforeend', window.tags)
  delete window.tags

  return <Provider {...{ store }}>{children}</Provider>
}

const BoostrapedApp = () => (
  <Bootstrap>
    <App />
  </Bootstrap>
)

export default BoostrapedApp
